export default "__VITE_PUBLIC_ASSET__b241751a__"